import { mutationCreateVisitReport } from "./mutations/mutationCreateVisitReport"
import { mutationDeleteVisitReport } from "./mutations/mutationDeleteVisitReport"
import { mutationUpdateVisitReport } from "./mutations/mutationUpdateVisitReport"
import { queryVisitReport } from "./queries/queryVisitReport"
import { queryVisitReportAttachment } from "./queries/queryVisitReportAttachment"
import { queryVisitReports } from "./queries/queryVisitReports"
import { queryVisitReportsOccasions } from "./queries/queryVisitReportsOccasions"
import { typeVisitReport } from "./visitReport"

const visitReportSchema = {
  types: [typeVisitReport],
  resolvers: {
    Query: {
      ...queryVisitReport,
      ...queryVisitReports,
      ...queryVisitReportsOccasions,
      ...queryVisitReportAttachment,
    },
    Mutation: {
      ...mutationDeleteVisitReport,
      ...mutationCreateVisitReport,
      ...mutationUpdateVisitReport,
    },
  },
}

export default visitReportSchema
